var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticClass: "create_table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("th", [_vm._v("Title")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.data[0].TITLE))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Type")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.data[0].TYPE))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Country/Region")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.data[0].COUNTRY_NM))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("SKU Code")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.data[0].SKU_CODE))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Model")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.data[0].NMMODEL))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Buyer")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.data[0].BUYER_CODE))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Attachment")]),
          _vm._v(" "),
          _c(
            "td",
            { staticClass: "no_padding" },
            [
              _c("innorix-download", {
                attrs: {
                  uploadId: _vm.data.CTTID,
                  serviceType: "hhp",
                  attachList: _vm.data,
                  encToken: _vm.encToken
                }
              }),
              _vm._v(" "),
              _vm.data.length > 0
                ? _c("dl", { staticClass: "attachment_link" }, [
                    _c("dt", [
                      _c(
                        "a",
                        {
                          staticClass: "txt_link",
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.toggleLink($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.TROUBLE.DOWN")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _c(
                        "ul",
                        _vm._l(_vm.data, function(file, index) {
                          return _c("li", { key: index }, [
                            _c(
                              "a",
                              {
                                staticClass: "txt_link",
                                attrs: {
                                  href: _vm.getDownloadUrl(file),
                                  target: "_blank",
                                  download: "",
                                  type: "application/octet-stream"
                                }
                              },
                              [
                                _c("span", { staticClass: "ico_attach" }),
                                _vm._v(
                                  " " +
                                    _vm._s(file.FILENAME) +
                                    "\n                                        "
                                )
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                : _c("div", [
                    _vm._v(
                      "\n                            No Attachment\n                        "
                    )
                  ])
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "topLine" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2775ca4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2775ca4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/findContent/FindContentView.vue
// module id = kGFv
// module chunks = 0